<script setup>
import { ref } from 'vue';
import StockScreenerDashboard from '@/tabs/my-screener/StockScreenerDashboard.vue';
import ScreenerStocks from '@/tabs/my-screener/ScreenerStocks.vue';
import AnLoader from '@/components/common/AnLoader.vue';
import { useUserStore } from '@/store/user-store';

const store = useUserStore();

const sectionId = ref(1);
const selectedScreener = ref(null);

const setSection = (id) => {
  sectionId.value = id;
};

const setSelectedScreener = (screener) => {
  selectedScreener.value = screener;
};
</script>

<template>
  <div>
    <!-- Show loader during screener data API call -->
    <AnLoader v-if="store.isDashboardLoading" text="Loading Stock Screeners..." />
    
    <!-- Show content only when not loading -->
    <div v-else>
      <section v-if="sectionId === 1">
        <StockScreenerDashboard :setSection="setSection" :setSelectedScreener="setSelectedScreener" />
      </section>
      <section v-else-if="sectionId === 2">
        <ScreenerStocks :setSection="setSection" :selectedScreener="selectedScreener" />
      </section>
    </div>
  </div>
</template>
